import { startsWith } from "lodash";
import { LocaleType } from "../../../constants/constants";

export class DefaultLanguageProvider {
    private readonly availableLanguages = [
        "en-GB", "fr-FR", "es-ES", "it-IT", "de-DE", "pl-PL",
    ];

    public get() {
        return this.fromLocalStorage || this.fromNavigator;
    }

    private get fromNavigator() {
        const language = navigator.language;
        if (startsWith(language, "fr")) {
            return "fr-FR" as LocaleType;
        }

        return "en-GB" as LocaleType;
    }

    private get fromLocalStorage() {
        const rawUserSettings = localStorage.getItem("user_settings");
        const language = rawUserSettings ?
            (JSON.parse(rawUserSettings) as { lang: string })?.lang ?? undefined :
            undefined;

        return language && this.isLanguageAvailable(language) ?
            language as LocaleType : undefined;
    }

    private isLanguageAvailable(lang: string) {
        return this.availableLanguages.includes(lang);
    }
}
